import PropTypes from 'prop-types';
// material
//import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  //const theme = useTheme();
  //const PRIMARY_LIGHT = theme.palette.primary.light;
  //const PRIMARY_MAIN = theme.palette.primary.main;
  //const PRIMARY_DARK = theme.palette.primary.dark;

  //const colorMode = theme.palette.mode;

  //const logoColor = (colorMode === 'dark') ? theme.palette.primary.logoDark  : theme.palette.primary.logoLight ;
  return (
    <Box sx={{ width: 40, height: 40, ...sx }}>

      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1065.55 946">
        {/* <defs>
          <linearGradient id="id0" x1="2092.43" y1="-665.05" x2="2051.44" y2="1845.5">
            <stop offset="0%" stopColor="#010102" stopOpacity="1" />
            <stop offset="100%" stopColor="#FA9D1C" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="id1" x1="2082.26" href="#id0" y1="1691.07" x2="1986.13" y2="5142.88">
          </linearGradient>
        </defs> */}


        <defs>
          <radialGradient id="radial-gradient" cx="530.67" cy="523.67" r="120.78"
            gradientTransform="matrix(1 0 0 1.17 0 -89.99)" gradientUnits="userSpaceOnUse">
            <stop offset=".01" stopColor="#e56326" />
            <stop offset=".02" stopColor="#e26226" />
            <stop offset=".13" stopColor="#cb5e27" />
            <stop offset=".23" stopColor="#bd5b28" />
            <stop offset=".32" stopColor="#b85a28" />
            <stop offset=".62" stopColor="#b65927" />
            <stop offset=".74" stopColor="#af5526" />
            <stop offset=".82" stopColor="#a34e23" />
            <stop offset=".89" stopColor="#92451e" />
            <stop offset=".95" stopColor="#7c3818" />
            <stop offset="1" stopColor="#612911" />
            <stop offset="1" stopColor="#602911" />
          </radialGradient>
          <radialGradient id="radial-gradient-2" cx="532.84" cy="123.82" r="14.97"
            gradientTransform="rotate(89.41 764.218 352.82) scale(1 4.7)" gradientUnits="userSpaceOnUse">
            <stop offset=".01" stopColor="#495761" />
            <stop offset=".26" stopColor="#46535d" />
            <stop offset=".49" stopColor="#3d4852" />
            <stop offset=".72" stopColor="#2e3640" />
            <stop offset=".93" stopColor="#181c27" />
            <stop offset=".99" stopColor="#11131e" />
          </radialGradient>
          <radialGradient id="radial-gradient-3" cx="535.59" cy="645.23" r="102.28"
            gradientTransform="rotate(88.22 722.994 826.973) scale(1 1.56)" gradientUnits="userSpaceOnUse">
            <stop offset=".01" stopColor="#faf9d9" />
            <stop offset=".02" stopColor="#faf6cd" />
            <stop offset=".05" stopColor="#f9eb9d" />
            <stop offset=".08" stopColor="#f8e273" />
            <stop offset=".11" stopColor="#f7da52" />
            <stop offset=".15" stopColor="#f7d437" />
            <stop offset=".18" stopColor="#f6cf25" />
            <stop offset=".22" stopColor="#f6cd1a" />
            <stop offset=".26" stopColor="#f6cc16" />
            <stop offset=".33" stopColor="#f2c417" />
            <stop offset=".46" stopColor="#e8ad1a" />
            <stop offset=".61" stopColor="#d7871f" />
            <stop offset=".79" stopColor="#bf5326" />
            <stop offset=".81" stopColor="#bc4c27" />
            <stop offset=".86" stopColor="#b94b26" />
            <stop offset=".9" stopColor="#b04724" />
            <stop offset=".93" stopColor="#a04120" />
            <stop offset=".96" stopColor="#89391b" />
            <stop offset=".99" stopColor="#6c2e14" />
            <stop offset="1" stopColor="#602911" />
          </radialGradient>
          <radialGradient id="radial-gradient-4" cx="531.33" cy="451.16" r="184.02"
            gradientTransform="matrix(.03 1 -.74 .02 850.45 -89.78)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#f6cc16" />
            <stop offset=".1" stopColor="#eab01a" />
            <stop offset=".31" stopColor="#d17a21" />
            <stop offset=".47" stopColor="#c25925" />
            <stop offset=".56" stopColor="#bc4c27" />
            <stop offset=".76" stopColor="#9c4d23" />
            <stop offset=".81" stopColor="#964921" />
            <stop offset=".89" stopColor="#853f1c" />
            <stop offset=".98" stopColor="#692f14" />
            <stop offset="1" stopColor="#602911" />
          </radialGradient>
          <radialGradient id="radial-gradient-5" cx="530.4" cy="317.04" r="226.1"
            gradientTransform="matrix(1 0 0 .62 -.82 123.77)" href="#radial-gradient-3" />
          <radialGradient id="radial-gradient-6" cx="534.86" cy="66.75" r="146.73" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#f8dd7a" />
            <stop offset=".01" stopColor="#f8dc73" />
            <stop offset=".07" stopColor="#f7d652" />
            <stop offset=".13" stopColor="#f7d237" />
            <stop offset=".18" stopColor="#f6cf25" />
            <stop offset=".25" stopColor="#f6cd1a" />
            <stop offset=".31" stopColor="#f6cc16" />
            <stop offset=".32" stopColor="#f4c916" />
            <stop offset=".53" stopColor="#d6861f" />
            <stop offset=".67" stopColor="#c35c25" />
            <stop offset=".75" stopColor="#bc4c27" />
            <stop offset=".82" stopColor="#b94b26" />
            <stop offset=".87" stopColor="#b04724" />
            <stop offset=".91" stopColor="#a04120" />
            <stop offset=".95" stopColor="#89391b" />
            <stop offset=".99" stopColor="#6c2e14" />
            <stop offset="1" stopColor="#602911" />
          </radialGradient>
          <radialGradient id="radial-gradient-7" cx="534.34" cy="57.48" r="118.31"
            gradientTransform="matrix(.02967 .99956 -.83963 .02492 566.98 -478.06)" href="#radial-gradient-6" />
          <radialGradient id="radial-gradient-8" cx="532.98" cy="236.3" r="46.56" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#f6cc16" />
            <stop offset=".12" stopColor="#eab01a" />
            <stop offset=".38" stopColor="#d17a21" />
            <stop offset=".57" stopColor="#c25925" />
            <stop offset=".67" stopColor="#bc4c27" />
            <stop offset=".76" stopColor="#b94b26" />
            <stop offset=".82" stopColor="#b04724" />
            <stop offset=".88" stopColor="#a04120" />
            <stop offset=".93" stopColor="#89391b" />
            <stop offset=".98" stopColor="#6c2e14" />
            <stop offset="1" stopColor="#602911" />
          </radialGradient>
          <radialGradient id="radial-gradient-9" cx="532.98" cy="218.94" r="47.68" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#a14323" />
            <stop offset=".24" stopColor="#973f20" />
            <stop offset=".63" stopColor="#7e3519" />
            <stop offset="1" stopColor="#602911" />
          </radialGradient>
          <radialGradient id="radial-gradient-10" cx="532.98" cy="253.52" r="46.95" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-11" cx="346.69" cy="353.02" r="26.28"
            gradientTransform="matrix(1 0 0 1.23 0 -81.15)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-12" cx="361.15" cy="349.03" r="26.28"
            gradientTransform="matrix(1 0 0 1.29 0 -100.53)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-13" cx="375.61" cy="345.04" r="26.28"
            gradientTransform="matrix(1 0 0 1.23 0 -79.41)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-14" cx="225.22" cy="496.64" r="19.05" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-15" cx="235.29" cy="496.64" r="19.05" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-16" cx="245.35" cy="496.64" r="19.05" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-17" cx="143.66" cy="394.02" r="14.94" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-18" cx="134.04" cy="395.28" r="15.82" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-19" cx="124.42" cy="397.6" r="17.45" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-20" cx="77.35" cy="353.02" r="26.28"
            gradientTransform="matrix(-1 0 0 1.23 796.22 -81.15)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-21" cx="91.82" cy="349.03" r="26.28"
            gradientTransform="matrix(-1 0 0 1.29 796.22 -100.53)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-22" cx="106.28" cy="345.04" r="26.28"
            gradientTransform="matrix(-1 0 0 1.23 796.22 -79.41)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-23" cx="-44.11" cy="496.64" r="19.05"
            gradientTransform="matrix(-1 0 0 1 796.22 0)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-24" cx="-34.05" cy="496.64" r="19.05"
            gradientTransform="matrix(-1 0 0 1 796.22 0)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-25" cx="-23.98" cy="496.64" r="19.05"
            gradientTransform="matrix(-1 0 0 1 796.22 0)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-26" cx="-125.68" cy="394.02" r="14.94"
            gradientTransform="matrix(1 0 0 -1 1047.57 788.05)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-27" cx="-135.3" cy="395.28" r="15.82"
            gradientTransform="matrix(1 0 0 -1 1066.81 790.56)" href="#radial-gradient-8" />
          <radialGradient id="radial-gradient-28" cx="-144.92" cy="397.6" r="17.45"
            gradientTransform="matrix(1 0 0 -1 1086.05 795.2)" href="#radial-gradient-8" />
          <linearGradient id="linear-gradient" x1="704.17" y1="666.16" x2="677.64" y2="786.07" gradientUnits="userSpaceOnUse">
            <stop offset=".03" stopColor="#f05825" />
            <stop offset=".22" stopColor="#ffc116" />
            <stop offset=".39" stopColor="#fbbf14" />
            <stop offset=".64" stopColor="#c65528" />
            <stop offset=".66" stopColor="#bb5226" />
            <stop offset=".74" stopColor="#a14c22" />
            <stop offset=".82" stopColor="#8f481f" />
            <stop offset=".9" stopColor="#84451e" />
            <stop offset=".99" stopColor="#80441d" />
          </linearGradient>
          <linearGradient id="linear-gradient-2" x1="474.11" y1="624.14" x2="527.67" y2="770.48"
            gradientUnits="userSpaceOnUse">
            <stop offset=".01" stopColor="#ec5628" />
            <stop offset=".39" stopColor="#fbbf14" />
            <stop offset=".6" stopColor="#c85328" />
            <stop offset=".61" stopColor="#c35227" />
            <stop offset=".69" stopColor="#a24c22" />
            <stop offset=".76" stopColor="#87471e" />
            <stop offset=".84" stopColor="#75441b" />
            <stop offset=".91" stopColor="#6a421a" />
            <stop offset="1" stopColor="#664119" />
          </linearGradient>
          <linearGradient id="linear-gradient-3" x1="598.52" y1="633.69" x2="561.16" y2="747.92"
            href="#linear-gradient-2" />
          <linearGradient id="linear-gradient-4" x1="448.92" y1="636.24" x2="501.48" y2="779.85"
            href="#linear-gradient-2" />
          <linearGradient id="linear-gradient-5" x1="614.9" y1="639.05" x2="577.53" y2="753.33"
            href="#linear-gradient-2" />
          <linearGradient id="linear-gradient-6" x1="628.74" y1="643.58" x2="591.39" y2="757.8"
            href="#linear-gradient-2" />
          <linearGradient id="linear-gradient-7" x1="380.7" y1="669.3" x2="433.28" y2="801.08" gradientUnits="userSpaceOnUse">
            <stop offset=".01" stopColor="#ec5628" />
            <stop offset=".39" stopColor="#f89b23" />
            <stop offset=".6" stopColor="#c85328" />
            <stop offset=".61" stopColor="#c35227" />
            <stop offset=".69" stopColor="#a24c22" />
            <stop offset=".76" stopColor="#87471e" />
            <stop offset=".84" stopColor="#75441b" />
            <stop offset=".91" stopColor="#6a421a" />
            <stop offset="1" stopColor="#664119" />
          </linearGradient>
          <linearGradient id="linear-gradient-8" x1="288.84" y1="388.27" x2="343.11" y2="437.08"
            gradientUnits="userSpaceOnUse">
            <stop offset=".01" stopColor="#e56326" />
            <stop offset=".04" stopColor="#e86d25" />
            <stop offset=".14" stopColor="#f08422" />
            <stop offset=".24" stopColor="#f59220" />
            <stop offset=".32" stopColor="#f7971f" />
            <stop offset=".42" stopColor="#ee8e20" />
            <stop offset=".59" stopColor="#d57624" />
            <stop offset=".75" stopColor="#b85a28" />
            <stop offset=".8" stopColor="#b25726" />
            <stop offset=".86" stopColor="#a14d22" />
            <stop offset=".93" stopColor="#853e1b" />
            <stop offset="1" stopColor="#602911" />
          </linearGradient>
          <linearGradient id="linear-gradient-9" x1="201.59" y1="427.77" x2="162.73" y2="467.27"
            href="#linear-gradient-8" />
          <linearGradient id="linear-gradient-10" x1="19.51" y1="388.27" x2="73.77" y2="437.08"
            gradientTransform="matrix(-1 0 0 1 796.22 0)" href="#linear-gradient-8" />
          <linearGradient id="linear-gradient-11" x1="-67.74" y1="427.77" x2="-106.6" y2="467.27"
            gradientTransform="matrix(-1 0 0 1 796.22 0)" href="#linear-gradient-8" />
          <linearGradient id="linear-gradient-12" x1="660.63" y1="710.8" x2="679.99" y2="785.48"
            gradientUnits="userSpaceOnUse">
            <stop offset=".03" stopColor="#ed6724" />
            <stop offset=".22" stopColor="#ffc116" />
            <stop offset=".44" stopColor="#fbbf14" />
            <stop offset=".73" stopColor="#c65528" />
            <stop offset=".75" stopColor="#bb5226" />
            <stop offset=".8" stopColor="#a14c22" />
            <stop offset=".86" stopColor="#8f481f" />
            <stop offset=".93" stopColor="#84451e" />
            <stop offset=".99" stopColor="#80441d" />
          </linearGradient>
          <linearGradient id="linear-gradient-13" x1="442.74" y1="745.87" x2="402.73" y2="836.24"
            gradientUnits="userSpaceOnUse">
            <stop offset=".01" stopColor="#f05d24" />
            <stop offset=".07" stopColor="#f06123" />
            <stop offset=".13" stopColor="#f26c22" />
            <stop offset=".19" stopColor="#f47e1f" />
            <stop offset=".25" stopColor="#f7991b" />
            <stop offset=".3" stopColor="#fbba16" />
            <stop offset=".32" stopColor="#fcc614" />
            <stop offset=".38" stopColor="#facc17" />
            <stop offset=".46" stopColor="#f3de21" />
            <stop offset=".49" stopColor="#efe826" />
            <stop offset=".58" stopColor="#f3df22" />
            <stop offset=".74" stopColor="#fdc517" />
            <stop offset=".76" stopColor="#ffc015" />
            <stop offset=".9" stopColor="#c96e22" />
            <stop offset=".94" stopColor="#b75227" />
            <stop offset=".99" stopColor="#6a4219" />
          </linearGradient>
        </defs>
        <g style={{isolation:"isolate"}}>
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_2-2" data-name="Layer 2">
              <path fill="url(#radial-gradient)"
                d="m669.41 432.57-9.87 37.04-57.69 216.74H463.91l-57.83-208.36-12.97-46.66 276.3 1.24z" />
              <path
                d="M423.21 657.13s0-3.81 2.14-5.68 19.93-17.82 19.93-17.82l23 17.26s8.71-.66 19.88 8.87 24.6 38.24 26.24 49.62-5.58 21.83-5.58 21.83-.5 7.08-.67 10a47.93 47.93 0 0 1-1.47 7.72s3.94 3 21.19.5S575 730.9 575 730.9s-6.4-2.3-6.73-3-1.58-3.06-1.58-3.06 5.68-38 8.64-45.4 18.59-27.07 21.67-29.04a82.13 82.13 0 0 1 9.18-4.53l14.12-10.47 11.43 5.71 1.62 2 9.46 7.68L644 652s-18.87 19.64-22.15 39.85 3.28 31.87-11.5 43-107.45 37.3-127 46.17-61.29-17.74-53.24-42.39 14-65.06 3.45-71.47-10.35-10.03-10.35-10.03Z"
                fill="#6d3214" />
              <ellipse cx="532.84" cy="123.82" rx="77.49" ry="14.19" fill="url(#radial-gradient-2)" />
              <path
                d="M483.87 654.07S512.33 695 510 721.44s-3.69 30.47-3.69 30.47l70.64-5s-5.69-29.12-5.69-49.21 21.1-45.13 21.1-45.13-59.86-17.85-108.49 1.5Z"
                fill="url(#radial-gradient-3)" />
              <path
                d="M629.79 543.35c0 51.75-44.53 93.7-99.45 93.7s-99.46-41.95-99.46-93.7 25.12-90.82 99-91.93c73.36-1.09 99.91 40.18 99.91 91.93Z"
                fill="url(#radial-gradient-4)" />
              <path fill="#2f1e0f"
                d="m669.41 432.57-9.87 37a75.12 75.12 0 0 0-31-12.58c-21.16-3.51-88.07-9.35-127.34-4.92-30.81 3.5-81.2 21.44-95.12 25.93l-13-46.66Z"
                style={{opacity:"0.52",mixBlendMode:"multiply"}} />
              <path
                d="M713.11 354.66c-2.62 94.73-79.65 91.46-178.69 91.46-67.87 0-126.33 3.68-157-26a62.08 62.08 0 0 1-8-9.43c-9.19-13.21-14.45-31.32-14.93-56.07-.27-13.16 4.75-25.69 14-37.08.87-1.07 1.77-2.13 2.71-3.18 28.61-32 91-54.07 162.67-54.07 98.96.04 180.69 42.28 179.24 94.37Z"
                fill="url(#radial-gradient-5)" />
              <path d="M614.51 130.82C606.12 179 572.33 215 531.92 215s-74.31-36.14-82.63-84.4q83.12 3.85 165.22.22Z"
                fill="url(#radial-gradient-6)" />
              <path
                d="M616.49 107.5c0 2.64-.07 5.26-.21 7.83a1649 1649 0 0 1-168.73-.24c-.15-2.5-.22-5-.22-7.59C447.33 48.14 485.19 0 531.92 0s84.57 48.14 84.57 107.5Z"
                fill="url(#radial-gradient-7)" />
              <path d="M579.81 242c0 2.87-93.66 2.87-93.66 0v-13.57a606.29 606.29 0 0 0 93.66 0Z"
                fill="url(#radial-gradient-8)" />
              <path d="M579.81 224.66c0 2.87-93.66 2.87-93.66 0v-13.59a605 605 0 0 0 93.66 0Z"
                fill="url(#radial-gradient-9)" />
              <path d="M579.81 259.24c0 2.87-93.66 2.87-93.66 0v-13.59a605 605 0 0 0 93.66 0Z"
                fill="url(#radial-gradient-10)" />
              <path
                d="M644 652c-.65.66-29.59 15.8-34 48.7s-2.83 41.82-2.83 41.82l169.48-12.2 1.31-39s-7.63-8.06-38.78-15.68S644 652 644 652Z"
                fill="url(#linear-gradient)" style={{stroke:'#e31958', strokeMiterlimit:'10', strokeWidth:'.36px'}} />
              <path fill="#3d1c0e" d="m117 376.92 1.47 16.54-2.94 19.48s.36-12.31 0-13.23 1.47-22.79 1.47-22.79Z" />
              <path d="M467.32 650.25s43.79 18.58 41.5 81l10.95-5.35s1.52-75.9-52.45-75.65Z"
                fill="url(#linear-gradient-2)" />
              <path d="M606.22 645.87a89.22 89.22 0 0 0-33 73.15l-6.51 5.86s-1.52-31.69 7.82-52.53 24.74-24.53 31.69-26.48Z"
                fill="url(#linear-gradient-3)" />
              <path
                d="M445.28 633.63c-.81.82-19.93 17.82-19.93 17.82s38.19-2.29 55.72 33.72c14.38 29.52 14.69 53.57 3.27 74.23l-7.07 13.6 18.22-2.17s19.3-54.94-1.63-87.84-48.58-49.36-48.58-49.36Z"
                fill="url(#linear-gradient-4)" />
              <path
                d="M620.3 635.4c-1.08.82-22.57 18-35.62 44.06s.55 71 .55 71l8.15-4.35s-12.78-44.6 6-72.61 32.36-32.36 32.36-32.36Z"
                fill="url(#linear-gradient-5)" />
              <path
                d="M642.81 650.84c-1.31-.58-9.46-7.68-9.46-7.68s-20.88 10.05-33.69 40.19-5.32 55-5.32 55l9.66-3.74S600.26 706 611.29 682s31.52-31.16 31.52-31.16Z"
                fill="url(#linear-gradient-6)" />
              <path
                d="M435.61 654.7s33.46 0 43.72 59.35-14.41 70.58-14.41 70.58l-86-35.17s-5.84-21.25-22.44-43.72-50.77-13.87-50.77-13.87 92.04-33.75 129.9-37.17Z"
                fill="url(#linear-gradient-7)" />

                <path d="M644 652c-.65.66-29.59 15.8-34 48.7s-2.83 41.82-2.83 41.82l169.48-12.2 1.31-39s-7.63-8.06-38.78-15.68S644 652 644 652Z"
                fill="url(#linear-gradient)" style={{stroke:'#e31958',strokeMiterlimit:'10',strokeWidth:'.36px'}} />
              <ellipse cx="324.67" cy="740.73" rx="48.92" ry="52.66" fill="#fbbf14" />
              <ellipse cx="744.35" cy="734.3" rx="57.9" ry="52.48" fill="#604119" />
              <path
                d="m374.32 405.18-4.94 5.55-8.9 10L273 519l-43-59.38 107.71-130s1.7-.9 4.32-2.25c8.14-4.2 25-12.87 25.91-12.87a10.55 10.55 0 0 1 .51 3.1c1.7 15.88 5.87 87.58 5.87 87.58Z"
                fill="url(#linear-gradient-8)" />
              <ellipse fill="#4e2612" cx="249.56" cy="496.24" rx="5.18" ry="27.01" />
              <ellipse fill="#4e2612" cx="239.25" cy="496.24" rx="5.18" ry="27.01" />
              <ellipse fill="#4e2612" cx="229.06" cy="496.24" rx="5.18" ry="27.01" />
              <path d="M230 459.62s-75.32-81-76.41-80.73-35.23 48-35.23 48l90.51 91.33 32.52-43.09Z"
                fill="url(#linear-gradient-9)" />
              <path fill="#2f1e0f"
                d="M389.19 403.61c-1.55 4.65.06 4.88-3.16 8.59s-1.5 7.67-6.4 8h-2.23a62.08 62.08 0 0 1-8-9.43l-8.9 10a31.11 31.11 0 0 1-4.31-2.88 37.44 37.44 0 0 1-7.93-7.61c-4.92-6.86-5.36-15.8-6.13-24.17a206.26 206.26 0 0 0-4.95-29.88c-1.13-4.8-2.47-9.58-3-14.5-.14-1.28-1-5.74.2-6.47 1-.63 3.49 1 5.09.15.8-.39 1.67-4.1 2.52-8 1-4.32 1.94-8.85 2.81-9.31 2.5-1.29 2.52 4.48 5 3.13 1.65-.93 8.36-4.76 9.52-6.26 2.5-3.15.8.58 3.88-2 1.84-1.55 5.31 1.19 7.74 1.45-.48-2 3.07-3.65 3.14-3.63 2 .32 2.6 4.86 3.62 6.56s.83 7.35 1.58 9.26c1.55 3.88-.44 4.63 1.35 8.37 4.54 9.38 4.79 31.75 8.82 41.35 2.69 6.38 1.49 11 2.48 17.86.77 5.55-.93 4.04-2.74 9.42Z" style={{opacity:'0.25'}} />
              <path d="m359.32 385.65-11.1 2.35a448.6 448.6 0 0 1-14.16-67.57l11.1-2.33a381.94 381.94 0 0 0 14.16 67.55Z"
                fill="url(#radial-gradient-11)" />
              <path d="m373.78 381.66-11.1 2.34a448.34 448.34 0 0 1-14.16-67.57l11.1-2.33a381.94 381.94 0 0 0 14.16 67.56Z"
                fill="url(#radial-gradient-12)" />
              <path d="m388.24 377.67-11.1 2.33A449.57 449.57 0 0 1 363 312.42l11.1-2.33a382.83 382.83 0 0 0 14.14 67.58Z"
                fill="url(#radial-gradient-13)" />
              <path d="M229.15 523.3h-6.83c-1.24-19.06-1.5-37.1 0-53.32h6.83c-1.78 17.02-1.56 34.86 0 53.32Z"
                fill="url(#radial-gradient-14)" />
              <path d="M239.22 523.3h-6.84c-1.24-19.06-1.49-37.1 0-53.32h6.84c-1.78 17.02-1.56 34.86 0 53.32Z"
                fill="url(#radial-gradient-15)" />
              <path d="M249.29 523.3h-6.84c-1.24-19.06-1.5-37.1 0-53.32h6.84c-1.78 17.02-1.57 34.86 0 53.32Z"
                fill="url(#radial-gradient-16)" />
              <path fill="url(#radial-gradient-17)" d="M140.65 373.11h6.01v41.83h-6.01z" />
              <path fill="url(#radial-gradient-18)" d="M131.03 373.11h6.01v44.34h-6.01z" />
              <path fill="url(#radial-gradient-19)" d="M121.41 373.11h6.01v48.98h-6.01z" />
              <path fill="#fbb435" d="m46.33 376.71-4.47-7.09-4.01 2.26 6 8.06 2.48-3.23z" />
              <path fill="#b14126" d="m28.61 374.86 9.24-2.98 6 8.06-.04 8.78-9.55-3.59-5.65-10.27z" />
              <path fill="#a96f29" d="m64.82 377.09 1.12 12.48-1.67-5.78.1-3.85.45-2.85z" />
              <path fill="#cd8029" d="m64.37 379.94-.22 9.51-20.31.16.01-9.67h20.52z" />
              <path fill="#fde152" d="m64.82 377.09-18.49-.38-2.48 3.23h20.52l.45-2.85z" />
              <path fill="#a96f29" d="m65.04 381.27.33 13.72-1.81 7.48v-16.8l1.48-4.4z" />
              <path fill="#cd8029" d="M42.78 385.67h20.78v16.8H42.78z" />
              <path fill="#fde152" d="m63.56 385.67 1.48-4.4-20.88-.19-1.38 4.59h20.78z" />
              <path fill="#cd8029" d="M21.16 385.43h17.66v14.28H21.16z" />
              <path fill="#fde152" d="m38.82 385.43 2.17-4.04-18.66.13-1.17 3.91h17.66z" />
              <path fill="#cd8029" d="M0 385.13h15.53v12.56H0z" />
              <path fill="#fde152" d="m15.53 385.13 3.09-3.32-17.59-.11L0 385.13h15.53z" />
              <path fill="#a96f29"
                d="m40.99 381.39.08 14.58-2.25 3.74v-14.28l2.17-4.04zM18.62 381.81l.08 13.39-3.17 2.49v-12.56l3.09-3.32zM63.2 388.58l.31 13-1.69 7.1v-15.93l1.38-4.17z" />
              <path fill="#cd8029" d="M42.41 392.75h19.41v15.93H42.41z" />
              <path fill="#fde152" d="m61.82 392.75 1.38-4.17-19.5-.19-1.29 4.36h19.41z" />
              <path fill="#cd8029" d="M22.21 392.52h16.5v13.55h-16.5z" />
              <path fill="#fde152" d="m38.71 392.52 2.02-3.83-17.42.13-1.1 3.7h16.5z" />
              <path fill="#cd8029" d="M2.45 392.24h14.51v11.91H2.45z" />
              <path fill="#fde152" d="m16.96 392.24 2.88-3.15-16.43-.11-.96 3.26h14.51z" />
              <path fill="#a96f29"
                d="m40.73 388.69.08 13.83-2.1 3.55v-13.55l2.02-3.83zM19.84 389.09l.08 12.7-2.96 2.36v-11.91l2.88-3.15z" />
              <path fill="#f16123" d="m117.14 377.65-1.66 22.06H62.55l3.49-23.34 51.1 1.28z" />
              <path fill="#964c22" d="M115.48 412.94v-13.23H62.55v15.99l52.93-2.76z" />
              <path fill="#b14126" d="m99.53 384.18-1.75-25.3s-15.35 8.55-15.35 9.25-.35 16.05-.35 16.05Z" />
              <path fill="#a6512b" d="m82.95 348.06 14.83 10.82-15.35 9.25-3.84-6.29 4.36-13.78z" />
              <path fill="#d69128" d="m69.16 341.25-4.53 10.12 14 10.47s4.67-13.43 4.37-13.78-13.84-6.81-13.84-6.81Z" />
              <path fill="#dda72d" d="M53.63 336.37s15.88 4.71 15.53 4.88-3.66 10.65-4.53 10.12S52.94 343 52.94 343Z" />
              <path fill="#ffce66" d="m53.63 336.37 3.71-1.64 13.27 4.81-1.44 1.71-15.54-4.88z" />
              <path fill="#fbb435" d="m82.95 348.06.55-2.04-13.04-6.77-1.29 2 13.78 6.81z" />
              <path fill="#d26e46" d="M97.78 358.88c-.14-.32-1.89-3.38-1.89-3.38L83.5 346l-.55 2Z" />
              <path fill="#3d1c0e" d="M82.08 384.18c-.18-.34-1.93-5.22-1.93-5.22l.58-13.48 1.7 2.65Z" />
              <path fill="#a96f29" d="m61.44 394.59.3 12.67-1.61 6.91v-15.52l1.31-4.06z" />
              <path fill="#cd8029" d="M41.78 398.65h18.36v15.52H41.78z" />
              <path fill="#fde152" d="m60.13 398.65 1.31-4.06-18.45-.19-1.21 4.25h18.35z" />
              <path fill="#cd8029" d="M22.67 398.43h15.61v13.2H22.67z" />
              <path fill="#fde152" d="m38.28 398.43 1.91-3.74-16.49.13-1.03 3.61h15.61z" />
              <path fill="#cd8029" d="M3.97 398.15h13.72v11.61H3.97z" />
              <path fill="#fde152" d="m17.7 398.15 2.73-3.07-15.55-.1-.9 3.17H17.7z" />
              <path fill="#a96f29"
                d="m40.19 394.69.07 13.48-1.98 3.45v-13.19l1.91-3.74zM20.43 395.08l.07 12.37-2.8 2.31v-11.61l2.73-3.07z" />
              <path fill="#ffce66" d="M25.36 341c.26.07 11.79-.13 11.79-.13L36 343.22l-12.45-.13Z" />
              <path fill="#dda72d" d="m35.73 343.18-.18 10.28-12.48.09.51-10.46 12.15.09z" />
              <path fill="#a96f29" d="m37.15 340.85.6 10.06-2.2 2.55.18-10.28 1.42-2.33z" />
              <path fill="#d69128" d="m35.55 353.46.08 10.09-12.46-.07-.1-9.93 12.48-.09z" />
              <path fill="#a96f29" d="m37.75 350.91.33 9.45-2.45 3.19-.08-10.09 2.2-2.55z" />
              <path fill="#a6512b" d="M37.85 371.88c-.15-.25-2.22-8.33-2.22-8.33l-12.46-.07 5.44 11.38Z" />
              <path fill="#c68032" d="m41.86 369.62-3.64-9.55-2.59 3.48 2.22 8.33 4.01-2.26z" />
              <path
                d="m691.23 405.18 4.94 5.55 8.9 10L792.52 519l43.08-59.34-107.72-130s-1.7-.9-4.32-2.25c-8.14-4.2-25-12.87-25.91-12.87a10.55 10.55 0 0 0-.51 3.1c-1.74 15.84-5.91 87.54-5.91 87.54Z"
                fill="url(#linear-gradient-10)" />
              <ellipse fill="#4e2612" cx="815.99" cy="496.24" rx="5.18" ry="27.01" />
              <ellipse fill="#4e2612" cx="826.3" cy="496.24" rx="5.18" ry="27.01" />
              <ellipse fill="#4e2612" cx="836.49" cy="496.24" rx="5.18" ry="27.01" />
              <path d="M835.6 459.62s75.33-81 76.41-80.73 35.23 48 35.23 48l-90.51 91.33-32.52-43.09Z"
                fill="url(#linear-gradient-11)" />
              <path style={{opacity:"0.25"}} fill="#2f1e0f"
                d="M676.36 403.61c1.55 4.65-.06 4.88 3.16 8.59s1.5 7.67 6.4 8h2.23a62.08 62.08 0 0 0 8-9.43l8.9 10a30 30 0 0 0 4.31-2.88 37.44 37.44 0 0 0 7.93-7.61c4.92-6.86 5.36-15.8 6.13-24.17a206.26 206.26 0 0 1 4.95-29.88 114 114 0 0 0 3-14.5c.14-1.28 1-5.74-.2-6.47-1-.63-3.49 1-5.09.15-.8-.39-1.67-4.1-2.52-8-1-4.32-1.94-8.85-2.81-9.31-2.49-1.29-2.52 4.48-5 3.13-1.65-.93-8.36-4.76-9.52-6.26-2.5-3.15-.8.58-3.88-2-1.84-1.55-5.31 1.19-7.73 1.45.47-2-3.07-3.65-3.15-3.63-2 .32-2.6 4.86-3.61 6.56s-.83 7.35-1.59 9.26c-1.55 3.88.44 4.63-1.35 8.37-4.53 9.38-4.79 31.75-8.82 41.35-2.69 6.38-1.49 11-2.48 17.86-.77 5.55.95 4.04 2.74 9.42Z" />
              <path d="m706.23 385.65 11.1 2.32a448.63 448.63 0 0 0 14.17-67.57l-11.11-2.33a381.94 381.94 0 0 1-14.16 67.58Z"
                fill="url(#radial-gradient-20)" />
              <path d="m691.77 381.66 11.1 2.32A448.34 448.34 0 0 0 717 316.41l-11.1-2.33a381.94 381.94 0 0 1-14.13 67.58Z"
                fill="url(#radial-gradient-21)" />
              <path d="m677.31 377.67 11.1 2.32a448.34 448.34 0 0 0 14.16-67.57l-11.1-2.33a382.83 382.83 0 0 1-14.16 67.58Z"
                fill="url(#radial-gradient-22)" />
              <path d="M836.4 523.3h6.84c1.24-19.06 1.49-37.1 0-53.32h-6.84c1.78 17.02 1.6 34.86 0 53.32Z"
                fill="url(#radial-gradient-23)" />
              <path d="M826.33 523.3h6.84c1.24-19.06 1.5-37.1 0-53.32h-6.84c1.78 17.02 1.56 34.86 0 53.32Z"
                fill="url(#radial-gradient-24)" />
              <path d="M816.27 523.3h6.84c1.24-19.06 1.49-37.1 0-53.32h-6.84c1.78 17.02 1.56 34.86 0 53.32Z"
                fill="url(#radial-gradient-25)" />
              <path transform="rotate(-180 921.895 394.025)" fill="url(#radial-gradient-26)"
                d="M918.89 373.11h6.01v41.83h-6.01z" />
              <path transform="rotate(-180 931.515 395.28)" fill="url(#radial-gradient-27)"
                d="M928.51 373.11h6.01v44.34h-6.01z" />
              <path transform="rotate(-180 941.135 397.6)" fill="url(#radial-gradient-28)"
                d="M938.13 373.11h6.01v48.98h-6.01z" />
              <path fill="#fbb435" d="m1019.22 376.71 4.47-7.09 4.01 2.26-6 8.06-2.48-3.23z" />
              <path fill="#b14126" d="m1036.94 374.86-9.24-2.98-6 8.06.04 8.78 9.55-3.59 5.65-10.27z" />
              <path fill="#a96f29" d="m1000.73 377.09-1.12 12.48 1.67-5.78-.1-3.85-.45-2.85z" />
              <path fill="#cd8029" d="m1001.18 379.94.22 9.51 20.31.16-.01-9.67h-20.52z" />
              <path fill="#fde152" d="m1000.73 377.09 18.49-.38 2.48 3.23h-20.52l-.45-2.85z" />
              <path fill="#a96f29" d="m1000.51 381.27-.33 13.72 1.81 7.48v-16.8l-1.48-4.4z" />
              <path fill="#cd8029" transform="rotate(-180 1012.38 394.065)" d="M1001.99 385.67h20.78v16.8h-20.78z" />
              <path fill="#fde152" d="m1001.99 385.67-1.48-4.4 20.88-.19 1.38 4.59h-20.78z" />
              <path fill="#cd8029" transform="rotate(-180 1035.56 392.57)" d="M1026.73 385.43h17.66v14.28h-17.66z" />
              <path fill="#fde152" d="m1026.73 385.43-2.16-4.04 18.66.13 1.16 3.91h-17.66z" />
              <path fill="#cd8029" transform="rotate(-180 1057.785 391.41)" d="M1050.02 385.13h15.53v12.56h-15.53z" />
              <path fill="#fde152" d="m1050.02 385.13-3.09-3.32 17.6-.11 1.02 3.43h-15.53z" />
              <path fill="#a96f29"
                d="m1024.57 381.39-.09 14.58 2.25 3.74v-14.28l-2.16-4.04zM1046.93 381.81l-.08 13.39 3.17 2.49v-12.56l-3.09-3.32zM1002.35 388.58l-.31 13 1.69 7.1v-15.93l-1.38-4.17z" />
              <path fill="#cd8029" transform="rotate(-180 1013.435 400.715)" d="M1003.73 392.75h19.41v15.93h-19.41z" />
              <path fill="#fde152" d="m1003.73 392.75-1.38-4.17 19.51-.19 1.28 4.36h-19.41z" />
              <path fill="#cd8029" transform="rotate(-180 1035.09 399.295)" d="M1026.84 392.52h16.5v13.55h-16.5z" />
              <path fill="#fde152" d="m1026.84 392.52-2.02-3.83 17.43.13 1.09 3.7h-16.5z" />
              <path fill="#cd8029" transform="rotate(-180 1055.845 398.195)" d="M1048.59 392.24h14.51v11.91h-14.51z" />
              <path fill="#fde152" d="m1048.59 392.24-2.88-3.15 16.43-.11.96 3.26h-14.51z" />
              <path fill="#a96f29"
                d="m1024.82 388.69-.08 13.83 2.1 3.55v-13.55l-2.02-3.83zM1045.71 389.09l-.08 12.7 2.96 2.36v-11.91l-2.88-3.15z" />
              <path fill="#f16123" d="m948.41 377.65 1.66 22.06H1003l-3.49-23.34-51.1 1.28z" />
              <path fill="#964c22" d="M950.07 412.94v-13.23H1003v15.99l-52.93-2.76z" />
              <path fill="#b14126" d="m966 384.18 1.75-25.3s15.36 8.55 15.36 9.25.34 16.05.34 16.05Z" />
              <path fill="#a6512b" d="m982.6 348.06-14.83 10.82 15.36 9.25 3.83-6.29-4.36-13.78z" />
              <path fill="#d69128" d="m996.39 341.25 4.53 10.12-14 10.47s-4.71-13.43-4.36-13.78 13.83-6.81 13.83-6.81Z" />
              <path fill="#dda72d" d="M1011.92 336.37s-15.88 4.71-15.53 4.88 3.66 10.65 4.53 10.12 11.7-8.37 11.7-8.37Z" />
              <path fill="#ffce66" d="m1011.92 336.37-3.71-1.64-13.26 4.81 1.44 1.71 15.53-4.88z" />
              <path fill="#fbb435" d="m982.6 348.06-.55-2.04 13.04-6.77 1.3 2-13.79 6.81z" />
              <path fill="#d26e46" d="M967.77 358.88c.14-.32 1.89-3.38 1.89-3.38l12.39-9.5.55 2Z" />
              <path fill="#3d1c0e" d="M983.47 384.18c.18-.34 1.93-5.22 1.93-5.22l-.58-13.48-1.69 2.65Z" />
              <path fill="#a96f29" d="m1004.11 394.59-.3 12.67 1.61 6.91v-15.52l-1.31-4.06z" />
              <path fill="#cd8029" transform="rotate(-180 1014.595 406.41)" d="M1005.42 398.65h18.36v15.52h-18.36z" />
              <path fill="#fde152" d="m1005.42 398.65-1.31-4.06 18.45-.19 1.21 4.25h-18.35z" />
              <path fill="#cd8029" transform="rotate(-180 1035.08 405.025)" d="M1027.28 398.43h15.61v13.2h-15.61z" />
              <path fill="#fde152" d="m1027.28 398.43-1.92-3.74 16.49.13 1.03 3.61h-15.6z" />
              <path fill="#cd8029" transform="rotate(-180 1054.715 403.955)" d="M1047.85 398.15h13.72v11.61h-13.72z" />
              <path fill="#fde152" d="m1047.86 398.15-2.74-3.07 15.55-.1.91 3.17h-13.72z" />
              <path fill="#a96f29"
                d="m1025.36 394.69-.07 13.48 1.99 3.45v-13.19l-1.92-3.74zM1045.12 395.08l-.07 12.37 2.81 2.31v-11.61l-2.74-3.07z" />
              <path fill="#ffce66" d="M1040.19 341c-.26.07-11.79-.13-11.79-.13l1.12 2.37 12.45-.13Z" />
              <path fill="#dda72d" d="m1029.83 343.18.17 10.28 12.48.09-.51-10.46-12.14.09z" />
              <path fill="#a96f29" d="m1028.4 340.85-.6 10.06 2.2 2.55-.17-10.28-1.43-2.33z" />
              <path fill="#d69128" d="m1030 353.46-.08 10.09 12.46-.07.1-9.93-12.48-.09z" />
              <path fill="#a96f29" d="m1027.8 350.91-.32 9.45 2.44 3.19.08-10.09-2.2-2.55z" />
              <path fill="#a6512b" d="M1027.7 371.88c.15-.25 2.22-8.33 2.22-8.33l12.46-.07-5.44 11.38Z" />
              <path fill="#c68032" d="m1023.69 369.62 3.64-9.55 2.59 3.48-2.22 8.33-4.01-2.26z" />
              <path
                d="M795 710.93c-6-18.85-34.11-27-65-20v-.23l-196.11 44.63 18.77 77.21 178-40.93a106.7 106.7 0 0 0 11.69-2.69l3.41-.78.52-.18c33.78-11.02 55.26-36.5 48.72-57.03Z"
                fill="url(#linear-gradient-12)" />
              <ellipse cx="540.71" cy="775.16" rx="64.92" ry="39.24" transform="rotate(-17.73 540.703 775.164)"
                fill="#dc6f27" />
              <path
                d="m376.77 730.49-.5-.19a93.05 93.05 0 0 0-36.17-6.93c-34.65 0-62.74 16.93-62.74 37.82 0 12 9.23 22.63 23.62 29.56l-.11.1 219.29 97.85 55.23-79.24Z"
                fill="url(#linear-gradient-13)" />
              <ellipse cx="555.17" cy="851.28" rx="65.63" ry="43.1" fill="#da5527" />
              <path d="m564 763.38-10.41 34.13s-14.4 3.06-21.71 13-29.72 69.12-29.72 69.12l-28.31-11.32Z"
                fill="#613717" />
              <path d="M529.24 736.81c1 .35 34.74 26.57 34.74 26.57l-93.67 109-34.75-30.32Z" fill="#fbd20d" />
              <path d="m450.55 901.34 19.76-29S436.93 840 435.9 840.71s-17 33.38-17 33.38Z" fill="#83491f" />
              <path fill="#a44d24" d="m541.04 827.68 65.18 55.76-2.35 62.56-64.4-60.47 1.57-57.85z" />
              <path fill="#f05724" d="m541.04 827.68 40.84-.26 67.01 54.71-42.67 1.31-65.18-55.76z" />
              <path fill="#c14e27" d="m648.89 882.13-3.4 61.25-41.62 2.62 2.35-62.56 42.67-1.31z" />
            </g>
          </g>
        </g>
      </svg>

      {/* <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512 512">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} fillRule="evenodd" stroke="none" strokeWidth="1">
          <path
            fill="url(#BG1)"
            d="M183.168 285.573l-2.918 5.298-2.973 5.363-2.846 5.095-2.274 4.043-2.186 3.857-2.506 4.383-1.6 2.774-2.294 3.939-1.099 1.869-1.416 2.388-1.025 1.713-1.317 2.18-.95 1.558-1.514 2.447-.866 1.38-.833 1.312-.802 1.246-.77 1.18-.739 1.111-.935 1.38-.664.956-.425.6-.41.572-.59.8-.376.497-.537.69-.171.214c-10.76 13.37-22.496 23.493-36.93 29.334-30.346 14.262-68.07 14.929-97.202-2.704l72.347-124.682 2.8-1.72c49.257-29.326 73.08 1.117 94.02 40.927z"
          />
          <path
            fill="url(#BG2)"
            d="M444.31 229.726c-46.27-80.956-94.1-157.228-149.043-45.344-7.516 14.384-12.995 42.337-25.267 42.337v-.142c-12.272 0-17.75-27.953-25.265-42.337C189.79 72.356 141.96 148.628 95.69 229.584c-3.483 6.106-6.828 11.932-9.69 16.996 106.038-67.127 97.11 135.667 184 137.278V384c86.891-1.611 77.962-204.405 184-137.28-2.86-5.062-6.206-10.888-9.69-16.994"
          />
          <path
            fill="url(#BG3)"
            d="M450 384c26.509 0 48-21.491 48-48s-21.491-48-48-48-48 21.491-48 48 21.491 48 48 48"
          />
        </g>
      </svg> */}
    </Box>
  );
}
